export class DriverCredentialAttribute {
    public id: number;
    public driverCredentialId: number;
    public driverAttributeTypeId: number;
    public effectiveDate;
    public endDate;
    public description: string;
    public updatedBy: string;
    public updatedDate;
    public isRemoved: boolean;
    public driverCredentialApplicationItemSourceTypeId: number;
}
